
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Lavorazione, StatoLavorazione, VariazioneLavorazione, Azione, ProgressoLavorazione as ProgressoDTO } from '@/models';
import { store, StoreActions, StoreMutations } from '@/store';
import dayjs from 'dayjs';
import { Loading } from '@/components';

@Component({
    components:{
        Loading,
    }
})
export default class ProgressoLavorazione extends Vue {

    public dialog: boolean = false;
    public currentBarcode: string = "";

    get loading () {
        return store.state.loading;
    }

    get canPrintEtichette() : boolean {
        return store.state.uiLavorazione.stampaEtichette.stampaDisponibile;
    }

    get stampaEtichetteRfidDisponibile() : boolean {
        return store.state.stampaEtichetteRfidDisponibile;
    }

    get stampaEtichetteNoRfidDisponibile() : boolean {
        return store.state.stampaEtichetteNoRfidDisponibile;
    }

    get canResetEPC() : boolean {
        return store.state.uiLavorazione.stampaEtichette.resetEpcDisponibile;
    }

    get lavorazione(): Lavorazione | undefined {
        return store.state.lavorazioneCorrente;
    }

    get headers(): any[] {
        let titoli = [
            {
                text: "Data Progresso",
                value: "Data Progresso",
                align: 'center',
                indice: "",
                sortable: false,
                barcode: ""
            }
        ];

        if(this.lavorazione != undefined) {
            let tipoTaglia: any = this.lavorazione.tipoTagliaDecodificato;
            let innerLavorazione : any = this.lavorazione.innerLavorazione;

            for (let index = 1; index <= 16; index++) {
                const nomeProp = `taglia${index.toString().padStart(2, '0')}`;
                const valProp: string = tipoTaglia[nomeProp];

                const barcodeNomeProp : string = `barcode${index.toString().padStart(2, '0')}`
                const barcodeValProp: string = innerLavorazione[barcodeNomeProp] || null;

                let end = valProp == undefined || valProp == '';
                if(!end) {
                    titoli.push({
                        text: valProp,
                        value: valProp,
                        align: 'center',
                        sortable: false,
                        indice: index.toString(),
                        barcode: barcodeValProp
                    })
                }
            }
        }

        return titoli;
    }

    get items(): any[] {
        let rows: any[] = [];

        if(this.lavorazione != undefined) {
            let capiTaglia: any = this.lavorazione.innerLavorazione;

            // Riga numero totali capi per lavorazione (tipoRiga: 0)
            let rigaTotali = { id: -2, tipoRiga: 0, values: [] as string[] };
            rigaTotali.values.push("")
            for (let index = 1; index <= this.headers.length-1; index++) {
                const nomeProp = `capi${index.toString().padStart(2, '0')}`;
                const valProp: string = "" + (parseInt(capiTaglia[nomeProp]) || "-");

                rigaTotali.values.push(valProp);
            }
            rows.push(rigaTotali);

            let progArrayValuesSum : number[] = Array(this.headers.length).fill(0);
            // TODO: righe progresso già associate alla lavorazione (tipoRiga: 1)
            this.lavorazione.progressiLavorazione.forEach(prog => {
                let rigaProg = this.prog2RigaProg(prog, progArrayValuesSum);
                rows.push(rigaProg);
            });

            //riga numero lavorazioni mancanti (tipoRiga: 3)
            let rigaMancanti = { id:-3, tipoRiga: 3, values: [] as string[] };
            rigaMancanti.values.push("Mancanti:");
            for (let index = 1; index <= this.headers.length-1; index++) {
                const totale = parseInt(rigaTotali.values[index]);
                let valProp: string = "";
                if(totale){
                    valProp = (totale - progArrayValuesSum[index] < 0 ? 0 : totale - progArrayValuesSum[index] ).toString();
                }

                rigaMancanti.values.push(valProp);
            }

            rows.push(rigaMancanti);

            // riga progresso corrente editabile (tipoRiga: 2)
            if(this.lavorazione.stato == StatoLavorazione.IN_CORSO_DI_LAVORAZIONE && this.lavorazione.progresso < 100 && !this.userIsAdmin) {
                rows.push(this.progressoAttivo);
            }


        }

        return rows;
    }

    get userIsAdmin() {
        return store.state.currentUsr.roles.find((x: string) => x.toLowerCase() == 'admin') != undefined;
    }

    _progressoAttivo: any = null;

    get progressoAttivo(): any {
        if(this._progressoAttivo == null || this._progressoAttivo == undefined) {
            this._progressoAttivo = { id: -1, tipoRiga: 2, values: [] as number[] };
            this.headers.forEach(h => this._progressoAttivo.values.push(0))
        }
        return this._progressoAttivo;
    }
    set progressoAttivo(progresso: any) {
        this._progressoAttivo = progresso;
    }

    invioProgresso() {
        if(!this.lavorazione) return;

        var totCapiProgresso = 0;
        const progAttivoValues = this.progressoAttivo.values.slice(1, this.progressoAttivo.values.length-1);

        progAttivoValues.forEach((v: number) => totCapiProgresso += v);
        if(totCapiProgresso <= 0) {
            alert("Nessun dato di progresso specificato per l'invio!");
            return;
        }

        let progresso: ProgressoDTO = {
            indice: -1,
            stato: '',
            idLavorazione: this.lavorazione.id,
            qtaTaglia01: progAttivoValues.length > 0 ? progAttivoValues[0] : 0,
            qtaTaglia02: progAttivoValues.length > 1 ? progAttivoValues[1] : 0,
            qtaTaglia03: progAttivoValues.length > 2 ? progAttivoValues[2] : 0,
            qtaTaglia04: progAttivoValues.length > 3 ? progAttivoValues[3] : 0,
            qtaTaglia05: progAttivoValues.length > 4 ? progAttivoValues[4] : 0,
            qtaTaglia06: progAttivoValues.length > 5 ? progAttivoValues[5] : 0,
            qtaTaglia07: progAttivoValues.length > 6 ? progAttivoValues[6] : 0,
            qtaTaglia08: progAttivoValues.length > 7 ? progAttivoValues[7] : 0,
            qtaTaglia09: progAttivoValues.length > 8 ? progAttivoValues[8] : 0,
            qtaTaglia10: progAttivoValues.length > 9 ? progAttivoValues[9] : 0,
            qtaTaglia11: progAttivoValues.length > 10 ?progAttivoValues[10] : 0,
            qtaTaglia12: progAttivoValues.length > 11 ?progAttivoValues[11] : 0,
            qtaTaglia13: progAttivoValues.length > 12 ?progAttivoValues[12] : 0,
            qtaTaglia14: progAttivoValues.length > 13 ?progAttivoValues[13] : 0,
            qtaTaglia15: progAttivoValues.length > 14 ?progAttivoValues[14] : 0,
            qtaTaglia16: progAttivoValues.length > 15 ?progAttivoValues[15] : 0
        };
        store.dispatch(StoreActions.InvioProgresso, progresso);
    }
    prog2RigaProg(progresso: ProgressoDTO, progArrayValuesSum: number[]): any {
        let riga = {
            id: progresso.indice,
            tipoRiga: 1,
            values: [] as string[],
            dataCreazione:progresso.dataCreazione,
            dataElaborazione: progresso.dataElaborazione,
            ddtResoData: progresso.ddtResoData
        };
        riga.values.push("");
        for (let index = 1; index <= this.headers.length-1; index++) {
            const nomeProp = `qtaTaglia${index.toString().padStart(2, '0')}`;
            const valProp: string = (progresso as any)[nomeProp].toString();
            progArrayValuesSum[index] = progArrayValuesSum[index] + ( parseInt(valProp) ? parseInt(valProp) : 0);
            riga.values.push(valProp);
        }

        return riga;
    }

    openBarcodeDialog(header: any) {
        store.commit(StoreMutations.SetSelectedEtichetta, {etichetta: header.barcode, indiceTaglia: header.indice});
        this.dialog = true;
    }

    get isStampaEtichettaLoading(): boolean{
        return store.state.uiLavorazione.stampaEtichette.loading;
    }

    get selectedEtichetta(): string {
        return store.state.uiLavorazione.stampaEtichette.etichetta;
    }

    stampaEtichettaPerLavorazioneETaglia(operazione: string){
        console.log(store.state.uiLavorazione.stampaEtichette.etichetta);
        console.log(store.state.lavorazioneCorrente);
        store.dispatch(StoreActions.StampaEtichettaPerLavorazioneETaglia, {operazione: operazione, idLavorazione: store.state.lavorazioneCorrente?.id});
    }
}

